module.exports = __webpack_public_path__ + "img/linkedin.0fe31c98.png";